
import { addNamespace } from '@/app/shared/utils/NamespaceHelper'
import {
  postCategory as postCategoryService,
  updateLevelName as updateLevelNameService,
  createProductCategoryClass as createProductCategoryClassService
} from '@/app/admin/Services'

const NAMESPACE = 'admin/category/'

const _types = {
  getters: {
    GET_PRODUCT_CATEGORIES: 'GET_PRODUCT_CATEGORIES'
  },
  actions: {
    ADD_CATEGORY: 'ADD_CATEGORY',
    UPDATE_LEVEL_NAME: 'UPDATE_LEVEL_NAME',
    CREATE_CLASS: 'CREATE_CLASS'
  },
  mutations: {
    ADD_CATEGORY: 'ADD_CATEGORY',
    UPDATE_LEVEL_NAME: 'UPDATE_LEVEL_NAME',
    ADD_CLASS: 'ADD_CLASS'
  }
}

export const Types = addNamespace(NAMESPACE, _types)

const Category = {
  namespaced: true,
  getters: {
    [_types.getters.GET_PRODUCT_CATEGORIES]: (state, getters, rootState) => {
      return rootState.desktopParameterConfig?.productCategoryFilters
    }
  },
  actions: {
    async [_types.actions.ADD_CATEGORY] ({ commit, rootState }, category) {
      const newCategory = await postCategoryService(category)
      commit(_types.mutations.ADD_CATEGORY, { rootState, newCategory, levelId: category.levelId })
    },
    async [_types.actions.UPDATE_LEVEL_NAME] ({ commit, rootState }, { levelId, name }) {
      await updateLevelNameService(levelId, name)
      commit(_types.mutations.UPDATE_LEVEL_NAME, { rootState, levelId, newName: name })
    },
    async [_types.actions.CREATE_CLASS] ({ commit, rootState }, className) {
      const response = await createProductCategoryClassService(className)
      commit(_types.mutations.ADD_CLASS, { rootState, classData: response })
      return response
    }
  },
  mutations: {
    [_types.mutations.ADD_CATEGORY] (_, { rootState, newCategory, levelId }) {
      const classTarget = rootState.desktopParameterConfig.productCategoryFilters.find(_class => _class.id === newCategory.class_id)
      const levelTarget = classTarget.levelList.find(level => level.levelId === levelId)
      levelTarget.options.push({ ...newCategory })
    },
    [_types.mutations.UPDATE_LEVEL_NAME] (_, { rootState, levelId, newName }) {
      const allClasses = rootState.desktopParameterConfig.productCategoryFilters
      for (const classData of allClasses) {
        const level = classData.levelList.find(level => level.id === levelId)
        if (level) {
          level.description = newName
          break
        }
      }
    },
    [_types.mutations.ADD_CLASS] (_, { rootState, classData }) {
      // Create the new class structure based on the API response
      const newClass = {
        id: classData.class_id,
        class: classData.class_name,
        levelList: [
          {
            id: classData.level_id,
            levelId: classData.level_id,
            description: classData.level_name,
            options: []
          }
        ]
      }

      // Add the new class to the productCategoryFilters array
      if (!rootState.desktopParameterConfig) {
        rootState.desktopParameterConfig = {}
      }
      if (!rootState.desktopParameterConfig.productCategoryFilters) {
        rootState.desktopParameterConfig.productCategoryFilters = []
      }

      rootState.desktopParameterConfig.productCategoryFilters.push(newClass)
    }
  }
}

export default Category



// WEBPACK FOOTER //
// ./src/app/admin/store/Category.js